import React from "react";
import BondDieFace from "./DieFace";

// Cube face layout (opposite faces sum to 7)
const CUBE_FACES = [
  { side: "front", value: 1 },
  { side: "back", value: 6 },
  { side: "right", value: 3 },
  { side: "left", value: 4 },
  { side: "top", value: 2 },
  { side: "bottom", value: 5 },
];

// Cube rotation that brings a given face toward the viewer
const SHOW_TRANSFORM = {
  1: "rotateX(0deg) rotateY(0deg)",
  2: "rotateX(-90deg) rotateY(0deg)",
  3: "rotateX(0deg) rotateY(-90deg)",
  4: "rotateX(0deg) rotateY(90deg)",
  5: "rotateX(90deg) rotateY(0deg)",
  6: "rotateX(0deg) rotateY(180deg)",
};

const DiceRollStage = ({ outcome, spinning = false, locked = false }) => {
  const hasOutcome = outcome != null && !spinning;
  const settledFace = hasOutcome
    ? Math.min(6, Math.max(1, Math.floor(Number(outcome))))
    : null;

  const state = spinning ? "spinning" : settledFace ? "settled" : locked ? "locked" : "idle";
  const cubeStyle = settledFace ? { transform: SHOW_TRANSFORM[settledFace] } : undefined;

  const ariaLabel = settledFace
    ? `Dice showing ${settledFace}`
    : locked
      ? "Dice reserved — roll pending"
      : "Dice rolling preview";

  return (
    <div className={`bdice-roll bdice-roll-3d bdice-roll-${state}`} aria-live="polite">
      <span className="bdice-roll-lane" aria-hidden />
      <div className="bdice3d-scene">
        <div className="bdice3d-cube" style={cubeStyle} aria-label={ariaLabel}>
          {CUBE_FACES.map(({ side, value }) => (
            <span key={side} className={`bdice3d-face ${side}`} aria-hidden>
              <BondDieFace value={value} size="lg" />
            </span>
          ))}
        </div>
      </div>
      <span className="bdice-roll-spark s1" aria-hidden />
      <span className="bdice-roll-spark s2" aria-hidden />
      <span className="bdice-roll-spark s3" aria-hidden />
      <span className="bdice-roll-shadow" aria-hidden />
    </div>
  );
};

export default DiceRollStage;
